/* Valentina Díaz · Marca 2026: animaciones suaves, guía de Klaviyo y video */
(function () {
  var io = null;
  function show(el) { el.classList.add('is-in'); }
  function scan() {
    var els = document.querySelectorAll('.vd-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(show); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); } else { scan(); }
  document.addEventListener('shopify:section:load', scan);
  setTimeout(function () { document.querySelectorAll('.vd-reveal:not(.is-in)').forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) show(el); }); }, 1500);

  document.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('[data-vd-klaviyo]');
    if (k && (window._klOnsite || window.klaviyo)) {
      e.preventDefault();
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', k.getAttribute('data-vd-klaviyo')]);
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-vd-play]');
    if (!btn) return;
    var frame = btn.closest('.vd-video__frame');
    var iframe = document.createElement('iframe');
    iframe.src = btn.getAttribute('data-vd-play');
    iframe.allow = 'autoplay; fullscreen; picture-in-picture';
    iframe.setAttribute('allowfullscreen', '');
    iframe.title = btn.getAttribute('aria-label') || 'Video';
    frame.innerHTML = '';
    frame.appendChild(iframe);
  });
})();
